import withHelmet from '../HOC/withHelmet';
import PricingPage from '../components/pricing';

export default withHelmet(PricingPage, 'Membership plans');
